export enum FrequenciaTipoEnum {
  PRESENTE = "PRE",
  ATRASADO = "ATR",
  AUSENTE = "AST",
}
